/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {Dialog,Cookies,Loading,LocalStorage,Notify} from 'quasar'



export default { config: {"notify":{},"loading":{},"brand":{"primary":"#5562a9","secondary":"#8093FF","accent":"#F05581","dark":"#1A1D2B","positive":"#21BA45","negative":"#C10015","info":"#48E2CA","warning":"#F2C037"}},plugins: {Dialog,Cookies,Loading,LocalStorage,Notify} }

